/**
 * NB: Feature names are prefixed with ascending numbers which dictate their respective message
 * namespaces. New features should be added to the end of the list with incrementing numbers, disregarding
 * alphabetisation. Namespace 000 is reserved by the framework.
 *
 * To ensure consistent message codes across versions, numbers should never be changed once used.
 * However, if a feature is removed, its number may be re-used by a future feature.
 */
import { declareFeatureNames } from "../../Player/Util/declareFeatureNames";
var FeatureName = declareFeatureNames([
    'COR_001_EXAMPLE_FEATURE',
    'COR_002_DEBUG',
    'COR_003_YOSPACE_ADS',
    'COR_004_CONFIGURATION',
    'COR_005_TARGET',
    'COR_006_TOGGLES',
    'COR_007_DOM',
    'COR_008_SOLUTION',
    'COR_009_PLAYBACK',
    'COR_010_PAUSE_PLAY',
    'COR_011_TIME_UPDATE',
    'COR_012_ENDING',
    'COR_013_UNLOAD_OR_ERROR',
    'COR_014_DESTROY',
    'COR_015_DRM',
    'COR_016_DRM_MANAGER',
    'COR_017_LOCAL_STORAGE',
    'COR_018_SEEKING',
    'COR_019_VOLUME',
    'COR_020_SPINNER',
    'COR_021_LOAD_MEDIA',
    'COR_022_PUBLIC_API_EVENTS',
    'COR_023_DAZN',
    'COR_024_LOAD_ASSET',
    'COR_025_RESILIENCE',
    'COR_026_ADS',
    'COR_027_AD_TAGS',
    'COR_028_GOOGLE_ADS',
    'COR_029_MULTIPLE_WINDOW',
    'COR_030_PLAYBACK_RATE',
    'COR_031_RESUME_POINTS',
    'COR_032_SOURCE_LIST',
    'COR_033_METADATA',
    'COR_034_CONCURRENCY',
    'COR_035_CONVIVA',
    'COR_036_ANALYTICS',
    'COR_037_AUDIO',
    'COR_038_CONNECTION_LOSS',
    'COR_039_CHROMECAST_SENDER',
    'COR_040_ERARO',
    'COR_041_END_OF_STREAM',
    'COR_042_NEW_RELIC',
    'COR_043_UI',
    'COR_044_MULTICAST',
    'COR_045_TOKENISATION',
    'COR_048_YOUTH_PROTECTION',
    'COR_049_LIFECYCLE',
    'COR_050_COMSCORE',
    'COR_051_FE_EVENTS',
    'COR_052_METRICS',
    'COR_053_ADAPTIVE_PRESENTATION_DELAY',
    'COR_054_NIELSEN',
    'COR_055_GOOGLE_PAL',
    'COR_056_LIVE_MONITORING',
    'COR_057_CLIENT_MULTIVIEW',
    'COR_058_AMAGI_FAST',
    'COR_059_BROADCAST_MULTIVIEW',
    'COR_060_WATCH_NEXT',
    'COR_061_CAPTIONS',
    'COR_062_HYPERCARE',
    'COR_063_CUSTOM_PSSH',
]);
export { FeatureName };
//# sourceMappingURL=FeatureName.js.map